module.exports = __webpack_public_path__ + "static/media/yellow-square.8241ecb8.svg";